import { all } from 'redux-saga/effects';
import bundleSagas from './bundles/sagas.js';
import configurationSagas from './configurations/sagas.js';

const productsSagas = [
    ...bundleSagas,
    ...configurationSagas
];
function* prescriptionGlassesSaga() {
    yield all(productsSagas);
}

export { prescriptionGlassesSaga as default, productsSagas };
//# sourceMappingURL=sagas.js.map
